'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StickyToolbar = require('./components/StickyToolbar.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StickyToolbar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-sticky-toolbar/lib/index.js
// module id = 1346
// module chunks = 1